function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { Fragment } from 'react';
import classNames from 'classnames';
import { TITLE_SIZES } from '../title/title';
import { EuiFlexGroup, EuiFlexItem } from '../flex';
import { EuiSpacer } from '../spacer';
import { EuiIcon, COLORS, IconPropType } from '../icon/icon';
import { EuiText, EuiTextColor } from '../text';
import { EuiTitle } from '../title';
export var EuiEmptyPrompt = function EuiEmptyPrompt(_ref) {
  var iconType = _ref.iconType,
      iconColor = _ref.iconColor,
      title = _ref.title,
      titleSize = _ref.titleSize,
      body = _ref.body,
      actions = _ref.actions,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["iconType", "iconColor", "title", "titleSize", "body", "actions", "className"]);

  var classes = classNames('euiEmptyPrompt', className);
  var icon;

  if (iconType) {
    icon = React.createElement(Fragment, null, React.createElement(EuiIcon, {
      type: iconType,
      size: "xxl",
      color: iconColor
    }), React.createElement(EuiSpacer, {
      size: "s"
    }));
  }

  var content;

  if (body || title) {
    var titleEl;

    if (title) {
      titleEl = React.createElement(Fragment, null, React.createElement(EuiTitle, {
        size: titleSize
      }, title), React.createElement(EuiSpacer, {
        size: "m"
      }));
    }

    var bodyEl;

    if (body) {
      bodyEl = React.createElement(Fragment, null, React.createElement(EuiText, null, body));
    }

    content = React.createElement(EuiTextColor, {
      color: "subdued"
    }, titleEl, bodyEl);
  }

  var actionsEl;

  if (actions) {
    var actionsRow;

    if (Array.isArray(actions)) {
      actionsRow = React.createElement(EuiFlexGroup, {
        gutterSize: "m",
        alignItems: "center",
        justifyContent: "center",
        direction: "column"
      }, actions.map(function (action, index) {
        return React.createElement(EuiFlexItem, {
          key: index,
          grow: false
        }, action);
      }));
    } else {
      actionsRow = actions;
    }

    actionsEl = React.createElement(Fragment, null, React.createElement(EuiSpacer, {
      size: "s"
    }), actionsRow);
  }

  return React.createElement("div", _extends({
    className: classes
  }, rest), icon, content, body && actions && React.createElement(EuiSpacer, {
    size: "l"
  }), actionsEl);
};
EuiEmptyPrompt.defaultProps = {
  iconColor: 'subdued'
};
EuiEmptyPrompt.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EuiEmptyPrompt",
  "props": {
    "iconColor": {
      "defaultValue": {
        "value": "'subdued'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "COLORS"
      },
      "required": false,
      "description": "Pass `null` to use original icon color"
    },
    "iconType": {
      "type": {
        "name": "custom",
        "raw": "IconPropType"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "titleSize": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "TITLE_SIZES"
      },
      "required": false,
      "description": ""
    },
    "body": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "actions": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};